import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Mustache from 'mustache';
import galleryModalHtml from './_modal.html';
import './style.scss';

class GalleryModal {
    constructor(params) {
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.init();
    }

    defaults(){
        return {
            imgList: [],
            overlayClose: true,
        }
    }

    init(){
        const rendered = Mustache.render(galleryModalHtml, {
            imgList: this.settings.imgList,
        });
        const modalObj = document.createElement('div');
        modalObj.innerHTML = rendered;
        document.querySelector('body').appendChild(modalObj);

        // 複数インスタンス(戸建一覧の棟ごとのモーダル等)が同時に存在しうるため、
        // documentワイドではなく自身が生成したDOM(modalObj)の中だけを検索する
        this.modal = modalObj.querySelector('.plugin-gallery-modal');
        this.pagination = this.modal.querySelector('.plugin-gallery-modal__pagination');
        this.slideCount = this.settings.imgList.length;
        this.$slider = $(this.modal.querySelector('.js-gallery-modal-slider'));

        this.modal.querySelector('.plugin-gallery-modal__close').addEventListener('click', (e) => {
            this.close();
        });
        if(this.settings.overlayClose){
            this.modal.querySelector('.plugin-gallery-modal__overlay').addEventListener('click', (e) => {
                this.close();
            });
        }

        if (this.slideCount > 1) {
            this.$slider
                .slick({
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    fade: true,
                    speed: 400,
                    infinite: true,
                    autoplay: false,
                })
                .on('afterChange', (event, slick, currentSlide) => {
                    this.updatePagination(currentSlide);
                });

            this.modal.querySelector('.plugin-gallery-modal__nav-prev').addEventListener('click', () => {
                this.$slider.slick('slickPrev');
            });
            this.modal.querySelector('.plugin-gallery-modal__nav-next').addEventListener('click', () => {
                this.$slider.slick('slickNext');
            });
        } else {
            this.modal.querySelector('.plugin-gallery-modal__nav').style.display = 'none';
            this.pagination.style.display = 'none';
        }
    }

    updatePagination(currentSlide){
        if (this.slideCount > 1) {
            this.pagination.textContent = `${currentSlide + 1} / ${this.slideCount}`;
        }
    }

    close(){
        document.querySelector('html').classList.remove('is-fixed');
        this.modal.classList.remove('is-show');
    }

    show(index = 0){
        if (this.slideCount > 1) {
            this.$slider.slick('slickGoTo', index, true);
            this.updatePagination(index);
        }
        this.modal.classList.add('is-show');
        document.querySelector('html').classList.add('is-fixed');
    }
}

export default GalleryModal;
